import { Box, Button } from '@mui/material';
import useBranchList from 'api/branchesList/useBranchesList';
import useDeleteProduct from 'api/productsList/useDeleteProduct/useDeleteProduct';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import PageSpinner from 'components/shared/pageSpinner/PageSpinner';
import BranchDisplacementModal from 'components/shared/productDetail/BranchDisplacementModal/BranchDisplacementModal';
import GroupBranchesDisplacementModal from 'components/shared/productDetail/BranchDisplacementModal/GroupBranchesDisplacementModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useBranchListTableColumns from 'hooks/branchesList/useBranchesListTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// last search string
let lastSearch = null;

const Branches = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getProductsList, loading, branchesList, pageRef] = useBranchList();

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isChangeOriginModalOpen, setIsChangeOriginModalOpen] = useState(false);
  const [isChangeGroupOriginModalOpen, setIsChangeGroupOriginModalOpen] =
    useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenProduct, setEditChosenProduct] = useState({});
  const [changeOriginChosenProduct, setChangeOriginChosenProduct] = useState(
    {},
  );
  const [selectedRows, setSelectedRows] = useState([]);

  const [deleteRequest] = useDeleteProduct();
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const { can } = usePermissions();

  const branchListPermissions =
    permissions.general.categories.globalSettings.productManagement.branchList;
  const productDetailPermission =
    permissions.general.categories.globalSettings.productManagement.productList
      .detail.view;

  const canDelete = can(branchListPermissions.delete);
  const canDetail = can(branchListPermissions.detail);
  const canReorder = can(branchListPermissions.reorder);
  const canGoToRoot = can(productDetailPermission);

  useEffect(() => {
    getProductsList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getProductsList({ page, count: pageSize });
  }, [page, pageSize]);

  const goToGraphPage = useCallback(
    // row => () => navigate(`/product-graph/${row.id}`),
    row => `/product-graph/${row.id}`,
    [],
  );

  const goToRootPage = useCallback(
    row => () => {
      navigate(`/productDetail/${row.guidOrigin}`);
    },
    [],
  );

  const goToInfoPage = useCallback(
    row => () => {
      console.log(row);
      navigate(`/branches/${row.id}`);
    },
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenProduct(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const changeOrigin = useCallback(
    row => () => {
      setChangeOriginChosenProduct(row);
      setIsChangeOriginModalOpen(true);
    },
    [],
  );

  const [columnsData] = useBranchListTableColumns({
    goToRootPage,
    goToGraphPage,
    deleteItem,
    editItem,
    changeOrigin,
    goToInfoPage,
    apiRef: tableRef,
    permissions: {
      canDetail,
      canDelete,
      canReorder,
      canGoToRoot,
    },
  });

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getProductsList, setIsDeleteModalOpen, setDeleteLoading);
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getProductsList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getProductsList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {canReorder && selectedRows?.length ? (
        <Box
          sx={{
            w: '100%',
            mt: 3,
            mb: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Button
            onClick={() => setIsChangeGroupOriginModalOpen(true)}
            variant="contained"
            color="secondary"
          >
            جابجایی گروهی
          </Button>
        </Box>
      ) : null}
      {Object.keys(branchesList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={branchesList[page]}
          rows={branchesList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
          setSelectedRows={rows => setSelectedRows(rows)}
          disableSelection={!canReorder}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canDelete && isDeleteModalOpen ? (
        <DeleteModal
          open={isDeleteModalOpen}
          title={deleteChosenLocation?.title}
          locationId={deleteChosenLocation?.id}
          deleteLoading={deleteLoading}
          handleClose={() => setIsDeleteModalOpen(false)}
          onDelete={deleteHandle}
        />
      ) : null}

      {canReorder && isChangeOriginModalOpen ? (
        <BranchDisplacementModal
          open={isChangeOriginModalOpen}
          branchGuid={changeOriginChosenProduct?.id}
          currentOrigin={changeOriginChosenProduct?.displayOrigin}
          handleClose={() => setIsChangeOriginModalOpen(false)}
          refetchDetails={() => {
            setIsChangeOriginModalOpen(false);
            getProductsList({ page, count: pageSize });
          }}
        />
      ) : null}

      {canReorder && isChangeGroupOriginModalOpen ? (
        <GroupBranchesDisplacementModal
          open={isChangeGroupOriginModalOpen}
          branchesGuids={selectedRows}
          handleClose={() => setIsChangeGroupOriginModalOpen(false)}
          refetchDetails={() => {
            setIsChangeGroupOriginModalOpen(false);
            getProductsList({ page, count: pageSize });
          }}
        />
      ) : null}
    </>
  );
};

export default Branches;
